import {
  Alert,
  Box,
  Container,
  List,
  ListItem,
  ListItemText,
  Paper,
  Skeleton,
  Stack,
  Tab,
  Tabs,
  Typography,
  Button,
  TextField,
  ImageList,
  ImageListItem,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  useMediaQuery,
  Card,
} from "@mui/material";
import { alpha } from "@mui/material/styles";
import redirectFill from "@iconify/icons-eva/arrow-back-fill";
import {
  getImage,
  reportIssuesList,
  socketTypeList,
  formatNumber,
} from "../../../util/Display";
import React, { useContext, useEffect, useLayoutEffect, useRef, useState, Fragment } from "react";
import { useParams, useLocation } from "react-router-dom";
import Constant from "../../../util/constants";
import Page from "../../Page";
import MarkerInformationTab from "../MarkerInformationTab";
import { StripeCheckout } from "./StripeCheckout";
import { PaymentForm } from "./PaymentForm";
import { PaymentStatusContainer } from "./PaymentStatusContainer";
import { paymentStyles } from "./payment.constants";
import { useCharger } from "../../../react-query/hooks/useCharger";
import { EmailComponent } from "./EmailComponent";
import { Context } from "../../../context";
import { is } from "../../../util/is";
import styled from "@emotion/styled";
import { LoadingButton } from "@mui/lab";
import { ReactComponent as CallUs } from "../../../image/chargerStationIcons/callUs.svg";
import { Icon } from "@iconify/react";
import axios from "axios";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import LiveHelpOutlinedIcon from "@mui/icons-material/LiveHelpOutlined";
import PhotoLibraryOutlinedIcon from "@mui/icons-material/PhotoLibraryOutlined";
import ChargemilesLogo from "../../../image/networkFilter/Chargemiles.png";

import { useTheme } from "@emotion/react";
import { MuiSnackBar } from "../../@material-extend";
import Token from "../../../util/Token";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Tooltip from "@mui/material/Tooltip";
import { useDomainConfig } from "../../../hooks/useDomainConfig";

const { imageMapper } = Constant;

export const StyledLoadingButton = styled(LoadingButton)(({ theme }) => ({
  fontSize: theme.spacing(2),
  [theme.breakpoints.down("md")]: {
    fontSize: "13px",
  },
}));

const StyledChargerTabs = styled(Tabs)(({ theme }) => ({
  width: '100%',
  maxWidth: '100%',
  minHeight: 'auto',
  boxSizing: 'border-box',
  '& .MuiTabs-flexContainer': {
    justifyContent: 'space-between',
    width: '100%',
    gap: theme.spacing(0.5),
  },
  '& .MuiTabs-indicator': {
    display: 'none',
  },
}));

const StyledChargerTab = styled(Tab)(({ theme }) => ({
  color: theme.palette.text.secondary,
  backgroundColor: theme.palette.background.paper,
  border: `1px solid ${alpha(theme.palette.grey[500], 0.24)}`,
  boxShadow: `0 1px 2px ${alpha(theme.palette.grey[500], 0.14)}`,
  borderRadius: 10,
  fontWeight: 700,
  fontSize: '0.72rem',
  textTransform: 'none',
  minHeight: 58,
  flex: '1 1 auto',
  minWidth: 0,
  margin: 0,
  padding: theme.spacing(0.75, 0.5),
  gap: 2,
  '& .MuiTab-iconWrapper': {
    marginBottom: '2px',
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: '0.65rem',
  },
  transition: 'all 0.25s cubic-bezier(0.4, 0, 0.2, 1)',
  '&:hover': {
    backgroundColor: alpha(theme.palette.primary.main, 0.06),
    borderColor: alpha(theme.palette.primary.main, 0.3),
    color: theme.palette.primary.main,
  },
  '&.Mui-selected': {
    color: 'white',
    borderColor: 'transparent',
    background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`,
    boxShadow: `0 4px 14px ${alpha(theme.palette.primary.main, 0.4)}`,
    transform: 'translateY(-1px)',
    '&:hover': {
      background: `linear-gradient(135deg, ${theme.palette.primary.dark} 0%, ${theme.palette.primary.main} 100%)`,
    },
  },
}));

const IssueButton = styled(Button)(({ theme }) => ({
  borderRadius: "10px",
  width: "100%",
}));

const a11yProps = (index) => {
  return {
    id: `charger-station-simple-tab-${index}`,
  };
};
// The Connectors tab (no `height` prop) renders at its natural size and reports
// it via `onMeasure`; the other tabs receive that height and scroll internally
// if taller. This keeps every tab the same height — so the email section below
// never shifts — while the Connectors tab itself never scrolls or shows a gap.
const TabPanel = (props) => {
  const { children, value, index, height, onMeasure, ...other } = props;
  const contentRef = useRef(null);

  useLayoutEffect(() => {
    if (value === index && contentRef.current && onMeasure) {
      onMeasure(contentRef.current.offsetHeight);
    }
  });

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box
          ref={contentRef}
          sx={{
            p: { xs: 1.5, sm: 2 },
            ...(height != null ? { height, overflowY: "auto" } : {}),
          }}
        >
          {children}
        </Box>
      )}
    </div>
  );
};

const HOW_IT_WORKS = [
  { icon: "eva:flash-outline", label: "Select connector" },
  { icon: "eva:email-outline", label: "Enter details & pay" },
  { icon: "eva:checkmark-circle-2-outline", label: "Charging starts" },
];

const SectionTitle = ({ children }) => (
  <Typography
    variant="h6"
    textAlign="center"
    sx={{
      fontWeight: 700,
      fontSize: { xs: "1rem", sm: "1.1rem" },
      letterSpacing: 0.2,
      color: "text.primary",
      mb: 2.5,
    }}
  >
    {children}
  </Typography>
);

const SelectedBadge = () => (
  <Box
    sx={{
      display: "flex",
      alignItems: "center",
      gap: 0.25,
      px: 1,
      py: 0.25,
      borderRadius: "6px",
      bgcolor: "primary.main",
      color: "#fff",
      fontSize: "0.65rem",
      fontWeight: 700,
      textTransform: "uppercase",
      whiteSpace: "nowrap",
      boxShadow: (t) => `0 2px 6px ${alpha(t.palette.primary.main, 0.4)}`,
    }}
  >
    <Icon icon="eva:checkmark-fill" width={12} height={12} />
    Selected
  </Box>
);

const ConnectGunNote = ({ sx }) => (
  <Box
    sx={{
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      gap: 0.75,
      px: 1.25,
      py: 0.75,
      borderRadius: "8px",
      bgcolor: (t) => alpha(t.palette.warning.main, 0.1),
      color: "warning.dark",
      ...sx,
    }}
  >
    <Icon icon="eva:info-outline" width={16} height={16} />
    <Typography variant="caption" sx={{ fontWeight: 600, textAlign: "center", lineHeight: 1.3, fontSize: { xs: "0.66rem", sm: "0.72rem" } }}>
      Please connect the charging gun to your EV before making the payment.
    </Typography>
  </Box>
);

const HowItWorks = () => (
  <Box sx={{ mb: 2 }}>
    <Typography
      component="p"
      textAlign="center"
      sx={{
        fontWeight: 700,
        letterSpacing: 1.2,
        textTransform: "uppercase",
        color: "text.secondary",
        mb: 1.5,
        fontSize: { xs: "0.66rem", sm: "0.72rem" },
      }}
    >
      Start charging in 3 steps
    </Typography>
    <Stack
      direction="row"
      justifyContent="center"
      alignItems="flex-start"
      spacing={0}
      sx={{ width: "100%" }}
    >
      {HOW_IT_WORKS.map((step, i) => (
        <Fragment key={step.label}>
          <Stack
            alignItems="center"
            spacing={0.5}
            sx={{ flex: 1, minWidth: 0, maxWidth: 110, px: 0.25 }}
          >
            <Box
              sx={{
                position: "relative",
                width: { xs: 32, sm: 36 },
                height: { xs: 32, sm: 36 },
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexShrink: 0,
                bgcolor: (t) => alpha(t.palette.primary.main, 0.1),
                color: "primary.main",
              }}
            >
              <Icon icon={step.icon} width={17} height={17} />
              <Box
                sx={{
                  position: "absolute",
                  top: -3,
                  right: -3,
                  width: 16,
                  height: 16,
                  borderRadius: "50%",
                  bgcolor: "primary.main",
                  color: "#fff",
                  fontSize: "0.6rem",
                  fontWeight: 700,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                {i + 1}
              </Box>
            </Box>
            <Typography
              variant="caption"
              textAlign="center"
              color="text.secondary"
              fontWeight={600}
              sx={{ lineHeight: 1.2, fontSize: { xs: "0.64rem", sm: "0.7rem" } }}
            >
              {step.label}
            </Typography>
          </Stack>
          {i < HOW_IT_WORKS.length - 1 && (
            <Box
              sx={{
                flex: "0 0 auto",
                pt: { xs: 0.75, sm: 1 },
                color: "text.disabled",
              }}
            >
              <Icon icon="eva:arrow-ios-forward-outline" width={16} height={16} />
            </Box>
          )}
        </Fragment>
      ))}
    </Stack>
    <ConnectGunNote sx={{ mt: 1.75 }} />
  </Box>
);

const getPriceDisplay = (item, domainConfig) => {
  if (item.priceType === "min" && item.priceperMin) {
    return `${formatNumber(item.priceperMin * 60, {
      style: "currency",
      currency: domainConfig.currency,
    })} per hour`;
  }

  if (item.priceperKW) {
    return `${formatNumber(item.priceperKW, {
      style: "currency",
      currency: domainConfig.currency,
    })} per kWh`;
  }

  return "N/A";
};

export const ChargerInformation = ({ locationDetail }) => {
  const params = useParams();
  const location = useLocation();
  const domainConfig = useDomainConfig();
  const chargerId = params.chargerId;
  const connectorId = params.connectorId;
  const {
    data: charger,
    isFetching,
    isError,
    error,
  } = useCharger(chargerId, location.search, { 
    refetchInterval: (data, query) => (query?.state?.error ? false : 5000) 
  });
  
  const getStatusColor = (status, theme) => {
    const s = status?.toUpperCase();
    if (s === "AVAILABLE" || s === "PREPARING") return theme.palette.success.main;
    if (s === "CHARGING" || s === "SUSPENDEDEV" || s === "SUSPENDEDEVSE" || s === "FINISHING" || s === "IN USE") return theme.palette.warning.main;
    if (s === "FAULTED" || s === "OFFLINE" || s === "UNAVAILABLE") return theme.palette.error.main;
    return theme.palette.grey[500]; // default dull grey for unknown
  };
  // const { data: connectors = [1, 2] } = useLiveConnectors(chargerId);
  const { user } = useContext(Context);
  const [isGuest, setGuest] = useState(false);
  const [email, setEmail] = useState("");
  // const [customerName, setCustomerName] = useState("");
  const [clientId, setClientId] = useState("");
  const [value, setValue] = useState(0);
  const [connector, setConnector] = useState();
  // Holds the last-known effective connector ID so it survives the connector
  // state reset that happens when charger polling detects CHARGING status.
  const connectorIdForStatus = useRef(null);
  const [showCardInfo, setShowCardInfo] = useState(false);
  const [chargerInfo, setChargerInfo] = useState({});
  const [reportIssue, setReportIssue] = useState(false);
  const [chargerData, setChargerData] = useState();
  const [networkFilters, setNetworkFilter] = useState([]);
  const [reportIssueData, setReportIssueData] = useState({
    issue: "",
    message: "",
    otherIssue: false,
    category: "",
  });
  const [faqData, setFaqData] = useState();
  const [reportStat, setReportStat] = useState({
    open: false,
    variant: "",
    message: "",
  });
  const [photoModal, setPhotoModal] = useState({ open: false, src: "" });
  const domain = domainConfig?.domain?.toLowerCase();

  const handleChange = (_, newValue) => {
    setReportIssue(false);
    setValue(newValue);
  };
  const [paymentStatus, setPaymentStatus] = useState({
    isDone: false,
    status: false,
    message: "",
  });

  const clientHandler = (showCardInfo, clientId) => {
    clientId && setClientId(clientId);
    setShowCardInfo(showCardInfo);
  };

  useEffect(() => {
    if (charger && charger.amenities) {
      let amenities = charger.amenities.split(",");
      chargerInfo.amenities = amenities || [];
      setChargerInfo(chargerInfo);
    }

    if (
      charger &&
      charger?.connectors?.length > 0 &&
      charger.status?.toUpperCase() === "A"
    ) {
      const isAvailable = (status) => {
        const s = status?.toUpperCase();
        return s === "AVAILABLE" || s === "PREPARING";
      };

      charger.connectors.forEach((conn) => {
        if (
          conn?.connector_id === parseInt(connectorId) &&
          isAvailable(conn?.status)
        ) {
          setConnector(conn);
        }
      });
    }
  }, [charger, connectorId]);

  // Handle deselecting connector if it becomes unavailable during polling
  useEffect(() => {
    if (connector && charger) {
      const resetConnectorState = () => {
        setConnector(null);
        setGuest(false);
        setShowCardInfo(false);
        setPaymentStatus({
          isDone: false,
          status: false,
          message: "",
        });
      };

      if (charger.status?.toUpperCase() !== "A") {
        resetConnectorState();
        return;
      }
      const updatedConn = charger.connectors?.find((c) => c.connector_id === connector.connector_id) 
                       || charger.evses?.find((e) => e.evse_id === connector.evse_id);
                       
      if (updatedConn && updatedConn.status?.toUpperCase() !== "AVAILABLE" && updatedConn.status?.toUpperCase() !== "PREPARING") {
        resetConnectorState();
      }
    }
  }, [charger]);

  useEffect(() => {
    if (connector) {
      connectorIdForStatus.current = !is.empty(connector?.ocpi_connector_id)
        ? connector?.ocpi_connector_id
        : connector?.connector_id;
    }
  }, [connector]);

  useEffect(() => {
    setEmail(user?.userDetail?.email || "");
  }, [user]);

  useEffect(() => {
    const getFaqData = async (chargerBoxId) => {
      let baseUrl = `${process.env.REACT_APP_CHARGEMILES_CMS_END_POINT}/v1/charger/${chargerBoxId}/faq`;
      try {
        let response = await axios(`${baseUrl}`, { method: "get" });
        if (response.status === 200) {
          let faq = response.data.faqs;
          setFaqData(faq);
        }
      } catch (error) {
        console.log(error);
      }
    };

    if (charger?.chargepoint_id) {
      getFaqData(charger.chargepoint_id);
    } else return;
  }, [charger]);

  useEffect(() => {
    const fetchData = async () => {
      let baseUrl = `${process.env.REACT_APP_API_END_POINT}v2/location/get-detail`;
      baseUrl = `${baseUrl}?id=${charger.portalId}`;
      try {
        let response = await axios(`${baseUrl}`, { method: "get" });
        if (response.data.data) {
          setChargerData(response.data.data);
        }
      } catch (error) {
        console.error(error.response);
      }
    };

    if (charger?.portalId) {
      fetchData();
    } else return;
  }, [charger?.portalId]);

  useEffect(() => {
    const _fetchNetworkFilters = async () => {
      let url = `${process.env.REACT_APP_API_END_POINT}v2/location/get-provider/${domain}`;

      try {
        const response = await axios.get(url);
        if (response.status === 200) {
          let updatedNetworkArr = response.data.data;
          setNetworkFilter(updatedNetworkArr);
        }
      } catch (error) {
        console.log(error);
      }
    };
    if (!(networkFilters.length > 0)) _fetchNetworkFilters();
  }, []);

  const onChangeOtherIssue = (e) => {
    e.preventDefault();
    setReportIssueData({
      ...reportIssueData,
      message: e.target.value,
      otherIssue: true,
    });
  };

  const onSubmitReportIssue = async () => {
    const report = ["LOCATION", "DETAIL", "CARD", "CABLE", "OTHER"];
    let payload = {
      issue: report[reportIssueData.issue],
      category: reportIssueData.category,
      comment: reportIssueData.message,
      locationId: chargerData?._id ? chargerData._id : "",
      charge_box_id: chargerData?.name ? chargerData?.name : "",
    };
    const { data } = Token.parsedToken();
    if (data._id) {
      payload = { ...payload, user: data._id };
    }

    if (reportIssueData.otherIssue) {
      try {
        let baseUrl = `${process.env.REACT_APP_CHARGEMILES_CMS_END_POINT}/v1/charger/${chargerData?.name}/report`;
        let response = await axios(`${baseUrl}`, {
          method: "post",
          data: payload,
        });
        if (response.status) {
          setReportStat({
            open: true,
            variant: "success",
            message: "Report Submitted Successfully",
          });
          setReportIssueData({
            issue: "",
            message: "",
            otherIssue: false,
            category: "",
          });
        }
      } catch (error) {
        setReportStat({
          open: true,
          variant: "error",
          message: "Something went wrong",
        });
        console.log(error);
      }
    } else return;
  };

  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const totalConnectors =
    (charger?.connectors?.length || 0) + (charger?.evses?.length || 0);
  const isSingleStation = totalConnectors === 1;

  // Height of the Connectors tab, applied to the other tabs so all tabs match
  // (keeps the email section below from shifting); other tabs scroll if taller.
  const [tabContentHeight, setTabContentHeight] = useState(null);

  // A free connector (no per-kWh/min/session price) charges for free, so the
  // amount/pay form shouldn't show for it (EmailComponent handles free start).
  const isConnectorFree =
    !!connector &&
    Number(connector.fixedFeeCharging || 0) <= 0 &&
    Number(connector.fixedFeeStarting || 0) <= 0 &&
    Number(connector.priceperKW || 0) <= 0 &&
    Number(connector.priceperMin || 0) <= 0;

  const getIcon = () => {
    let provider = networkFilters.filter(
      (network) => network.name === chargerData.provider
    );
    if (!provider)
      provider = networkFilters.filter((network) => network.name === "GENERIC");

    return (
      <img
        style={{ height: "30px", width: "30px" }}
        src={provider[0]?.icon ? `${provider[0].icon}?v=2` : provider[0]?.icon}
        alt="Logo"
      />
    );
  };
  return (
    <Page
      title="Dashboard | Charger-UI"
      sx={{ marginTop: { xs: "8px", md: "16px" } }}
    >
      <Container
        sx={{
          padding: {
            xs: "0",
            sm: "0",
            md: "24px",
            lg: "24px",
            xl: "24px",
          },
          width: "100%",
          marginLeft: "auto",
          marginRight: "auto",
        }}
        style={{ maxWidth: "800px" }}
      >
        <Card sx={{
          pb: 2,
          boxShadow: (theme) => theme.customShadows?.z24 || '0 0 4px 0 rgba(145,158,171,0.24), 0 24px 48px 0 rgba(145,158,171,0.24)',
          borderRadius: 3,
          overflow: "hidden"
        }}>
        {paymentStatus.isDone ? (
          <PaymentStatusContainer
            status={paymentStatus.status}
            message={paymentStatus.message}
            chargerId={chargerId}
            connectorId={connectorIdForStatus.current}
            email={email}
          />
        ) : (
          <>
            {isError && (
              <Alert
                variant="outlined"
                severity="error"
                sx={{ m: 2, color: "red" }}
              >
                {error?.response?.data?.message ??
                  "Some error occured while loading charger details"}
              </Alert>
            )}
              <Box
                sx={{
                  background: (theme) => `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`,
                  color: '#fff',
                  p: { xs: 1.75, sm: 2.25 },
                }}
              >
                <Stack direction="row" alignItems="center" spacing={1.25}>
                  {networkFilters && chargerData ? (
                    <Box sx={{ bgcolor: '#fff', borderRadius: '50%', p: 0.5, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                      {getIcon()}
                    </Box>
                  ) : null}
                  <Box sx={{ flexGrow: 1, minWidth: 0, textAlign: 'left' }}>
                    <Typography
                      variant="h6"
                      fontWeight={700}
                      color="inherit"
                      noWrap
                      sx={{ fontSize: { xs: "1.05rem", sm: "1.25rem" }, lineHeight: 1.25 }}
                    >
                      {!is.empty(charger)
                        ? !is.empty(charger.chargepoint_name)
                          ? charger.chargepoint_name
                          : "N/A"
                        : ""}
                    </Typography>
                    {!is.empty(charger?.chargepoint_id) && (
                      <Box
                        component="span"
                        sx={{
                          display: "inline-flex",
                          alignItems: "center",
                          gap: 0.5,
                          mt: 0.5,
                          px: 1,
                          py: 0.25,
                          borderRadius: "6px",
                          bgcolor: "rgba(255,255,255,0.18)",
                          fontSize: { xs: "0.65rem", sm: "0.7rem" },
                          fontWeight: 700,
                          letterSpacing: 0.5,
                        }}
                      >
                        <Icon icon="eva:flash-outline" width={13} height={13} />
                        {charger.chargepoint_id}
                      </Box>
                    )}
                    {!isError && (
                      <Typography
                        variant="body2"
                        color="rgba(255,255,255,0.85)"
                        sx={{ fontSize: { xs: "0.72rem", sm: "0.8rem" }, lineHeight: 1.3 }}
                      >{`${charger?.name ?? ""} ${charger?.house_number ?? ""} ${
                        charger?.street ?? ""
                      }`}</Typography>
                    )}
                  </Box>
                  <Stack direction="row" spacing={0.5} sx={{ flexShrink: 0 }}>
                    <Tooltip title="Call Us">
                      <span>
                        <IconButton
                          size="small"
                          component="a"
                          href={
                            chargerData?.phone || chargerData?.alternatePhone
                              ? `tel:${chargerData?.phone || chargerData?.alternatePhone}`
                              : undefined
                          }
                          disabled={!(chargerData?.phone || chargerData?.alternatePhone)}
                          sx={{
                            color: '#fff',
                            bgcolor: 'rgba(255,255,255,0.18)',
                            '&:hover': { bgcolor: 'rgba(255,255,255,0.3)' },
                            '&.Mui-disabled': { color: 'rgba(255,255,255,0.4)', bgcolor: 'rgba(255,255,255,0.08)' },
                          }}
                        >
                          <Icon icon="eva:phone-call-outline" width={18} height={18} />
                        </IconButton>
                      </span>
                    </Tooltip>
                    <Tooltip title="Report Issue">
                      <IconButton
                        size="small"
                        onClick={() => setReportIssue(true)}
                        sx={{
                          color: '#fff',
                          bgcolor: 'rgba(255,255,255,0.18)',
                          '&:hover': { bgcolor: 'rgba(255,255,255,0.3)' },
                        }}
                      >
                        <Icon icon="eva:alert-triangle-outline" width={18} height={18} />
                      </IconButton>
                    </Tooltip>
                  </Stack>
                </Stack>
              </Box>
            <Box sx={{ px: 2, pt: 2 }}>
              <HowItWorks />
            </Box>
            <Box
              sx={{
                mx: 2,
                mt: 1,
                mb: 2,
                border: (t) => `1.5px solid ${alpha(t.palette.grey[500], 0.28)}`,
                borderRadius: 3,
                overflow: "hidden",
              }}
            >
            <Box
              sx={{
                p: 1.5,
                borderBottom: (t) => `1px solid ${alpha(t.palette.grey[500], 0.2)}`,
                bgcolor: (t) => alpha(t.palette.grey[500], 0.04),
              }}
            >
              <StyledChargerTabs
                value={value}
                onChange={handleChange}
                aria-label="icon tabs example"
                centered
              >
                <StyledChargerTab
                  icon={<Icon icon="eva:charging-outline" width={22} height={22} />}
                  iconPosition="top"
                  label="Connectors"
                  aria-label="Connectors"
                  {...a11yProps(0)}
                />
                <StyledChargerTab
                  icon={<Icon icon="eva:info-outline" width={22} height={22} />}
                  iconPosition="top"
                  label="Info"
                  aria-label="Information"
                  {...a11yProps(1)}
                />
                <StyledChargerTab
                  icon={<Icon icon="eva:message-circle-outline" width={22} height={22} />}
                  iconPosition="top"
                  label="FAQs"
                  aria-label="FAQs"
                  {...a11yProps(2)}
                />
                <StyledChargerTab
                  icon={<Icon icon="eva:image-outline" width={22} height={22} />}
                  iconPosition="top"
                  label="Photos"
                  aria-label="Photos"
                  {...a11yProps(3)}
                />
              </StyledChargerTabs>
            </Box>
            {!reportIssue && (
              <TabPanel
                value={value}
                index={0}
                onMeasure={setTabContentHeight}
                className="tab-list tab-location"
              >
                <Box className="tabs-parent" sx={{ ...paymentStyles.tabParent, mb: 0 }}>
                  <List
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      flexWrap: "nowrap",
                      justifyContent: "safe center",
                      gap: "0.75rem",
                      overflowX: isSingleStation ? "visible" : "auto",
                      pb: isSingleStation ? 0 : 1,
                      scrollSnapType: isSingleStation ? "none" : "x mandatory",
                      WebkitOverflowScrolling: "touch",
                      "&::-webkit-scrollbar": { height: "6px" },
                      "&::-webkit-scrollbar-thumb": {
                        backgroundColor: "rgba(145,158,171,0.4)",
                        borderRadius: "3px",
                      },
                    }}
                  >
                    {charger &&
                      charger?.connectors?.map((item, i) => {
                        const itemStatus = charger.status?.toUpperCase() !== "A" ? "UNAVAILABLE" : item.status;
                        return (
                        <Fragment key={item.connector_id || i}>
                          {item && (
                            <ListItem
                              sx={{
                                padding: "0px",
                                cursor: "pointer",
                                flex: "0 0 auto",
                                width: isSingleStation ? "100%" : { xs: "46%", sm: 168 },
                                maxWidth: isSingleStation ? "none" : 200,
                                scrollSnapAlign: "start",
                              }}
                              onClick={() =>
                                itemStatus.toUpperCase() === "AVAILABLE" ||
                                itemStatus.toUpperCase() === "PREPARING"
                                  ? setConnector(item)
                                  : setConnector()
                              }
                            >
                              <Paper
                                elevation={0}
                                sx={{
                                  width: "100%",
                                  height: "100%",
                                  borderRadius: "16px",
                                  border: "2px solid",
                                  borderColor: item.connector_id === connector?.connector_id ? "primary.main" : alpha(getStatusColor(itemStatus, theme), 0.5),
                                  boxShadow: item.connector_id === connector?.connector_id
                                    ? `0 8px 24px ${alpha(theme.palette.primary.main, 0.16)}`
                                    : '0 2px 8px rgba(145,158,171,0.12)',
                                  overflow: "hidden",
                                  transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                                  backgroundColor: item.connector_id === connector?.connector_id ? alpha(theme.palette.primary.main, 0.04) : "#ffffff",
                                  display: 'flex',
                                  flexDirection: 'column',
                                  alignItems: 'center',
                                  textAlign: 'center',
                                  gap: 0.75,
                                  p: 1.5,
                                  '&:hover': {
                                    boxShadow: item.connector_id !== connector?.connector_id ? '0 4px 12px rgba(145,158,171,0.16)' : '',
                                    transform: 'translateY(-2px)'
                                  }
                                }}
                              >
                                <Box
                                  sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    flexShrink: 0,
                                    width: 56,
                                    height: 56,
                                    borderRadius: '14px',
                                    backgroundColor: item.connector_id === connector?.connector_id ? alpha(theme.palette.primary.main, 0.1) : alpha(getStatusColor(itemStatus, theme), 0.08),
                                    '& svg, & img, & span svg': {
                                      width: '38px !important',
                                      height: '38px !important',
                                      fill: item.connector_id === connector?.connector_id ? theme.palette.primary.main : theme.palette.text.secondary,
                                      transition: 'all 0.3s ease',
                                    }
                                  }}
                                >
                                  {item.connectorType ? (
                                    <span style={{ display: 'flex' }}>
                                      {
                                        socketTypeList.find(
                                          (socket) =>
                                            socket.value ===
                                            (item.connectorType === "null" || !item.connectorType
                                              ? "connector1"
                                              : item.connectorType)
                                        ).src
                                      }
                                    </span>
                                  ) : (
                                    getImage(imageMapper.FAULT_CONNECTOR_IMAGE)
                                  )}
                                </Box>

                                <Typography variant="subtitle2" fontWeight={700} color="text.primary" noWrap sx={{ fontSize: '0.85rem', maxWidth: '100%', lineHeight: 1.2 }}>
                                  {socketTypeList.find(
                                    (socket) =>
                                      socket.value ===
                                      (item.connectorType === "null" || !item.connectorType
                                        ? "connector1"
                                        : item.connectorType)
                                  ).type || "N/A"}
                                </Typography>
                                <Typography variant="caption" color="text.secondary" fontWeight={600} sx={{ fontSize: '0.72rem' }}>
                                  {item.kw || "N/A"} KW
                                </Typography>
                                <Typography variant="caption" fontWeight={700} color="text.primary" sx={{ fontSize: '0.75rem', lineHeight: 1.2 }}>
                                  {getPriceDisplay(item, domainConfig)}
                                </Typography>
                                {item.connector_id === connector?.connector_id ? (
                                  <SelectedBadge />
                                ) : (
                                  <Box
                                    sx={{
                                      px: 1,
                                      py: 0.25,
                                      borderRadius: '6px',
                                      backgroundColor: alpha(getStatusColor(itemStatus, theme), 0.12),
                                      color: getStatusColor(itemStatus, theme),
                                      fontSize: '0.62rem',
                                      fontWeight: 700,
                                      textTransform: 'uppercase'
                                    }}
                                  >
                                    {itemStatus}
                                  </Box>
                                )}
                              </Paper>
                          </ListItem>
                          )}
                        </Fragment>
                      )})}
                    {charger &&
                      charger?.evses?.map((evse, i) => {
                        const evseStatus = charger.status?.toUpperCase() !== "A" ? "UNAVAILABLE" : evse.status;
                        return (
                        <ListItem
                          sx={{
                            padding: "0px",
                            cursor: "pointer",
                            flex: "0 0 auto",
                            width: isSingleStation ? "100%" : { xs: "46%", sm: 168 },
                            maxWidth: isSingleStation ? "none" : 200,
                            scrollSnapAlign: "start",
                          }}
                          key={evse.evse_id || i}
                          onClick={() =>
                            evseStatus.toUpperCase() === "AVAILABLE" && setConnector(evse)
                          }
                          selected={connector?.uid === evse.uid}
                          disabled={evseStatus.toUpperCase() !== "AVAILABLE"}
                        >
                          <Paper
                            elevation={0}
                            sx={{
                              width: "100%",
                              height: "100%",
                              borderRadius: "16px",
                              border: "2px solid",
                              borderColor: connector?.uid === evse.uid ? "primary.main" : alpha(getStatusColor(evseStatus, theme), 0.5),
                              boxShadow: connector?.uid === evse.uid
                                ? `0 8px 24px ${alpha(theme.palette.primary.main, 0.16)}`
                                : '0 2px 8px rgba(145,158,171,0.12)',
                              overflow: "hidden",
                              transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                              backgroundColor: connector?.uid === evse.uid ? alpha(theme.palette.primary.main, 0.04) : "#ffffff",
                              display: 'flex',
                              flexDirection: 'column',
                              alignItems: 'center',
                              textAlign: 'center',
                              gap: 0.75,
                              p: 1.5,
                              '&:hover': {
                                boxShadow: connector?.uid !== evse.uid ? '0 4px 12px rgba(145,158,171,0.16)' : '',
                                transform: 'translateY(-2px)'
                              }
                            }}
                          >
                            <Box
                              sx={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                flexShrink: 0,
                                width: 56,
                                height: 56,
                                borderRadius: '14px',
                                backgroundColor: evse.uid === connector?.uid ? alpha(theme.palette.primary.main, 0.1) : alpha(getStatusColor(evseStatus, theme), 0.08),
                                '& svg, & img, & span svg': {
                                  width: '38px !important',
                                  height: '38px !important',
                                  fill: evse.uid === connector?.uid ? theme.palette.primary.main : theme.palette.text.secondary,
                                  transition: 'all 0.3s ease',
                                }
                              }}
                            >
                              <img
                                src={getImage(
                                  imageMapper.FAULT_CONNECTOR_IMAGE
                                )}
                                alt={"img"}
                              />
                            </Box>

                            <Typography variant="subtitle2" fontWeight={700} color="text.primary" noWrap sx={{ fontSize: '0.85rem', maxWidth: '100%', lineHeight: 1.2 }}>
                              Connector {evse.evse_id.slice(-2) || evse.evse_id}
                            </Typography>
                            <Typography variant="caption" color="text.secondary" fontWeight={600} sx={{ fontSize: '0.72rem' }}>
                              {`${(
                                (1 *
                                  evse.connectors[0].voltage *
                                  evse.connectors[0].amperage) /
                                1000
                              ).toFixed(3) || "N/A"} KW`}
                            </Typography>
                            {connector?.uid === evse.uid ? (
                              <SelectedBadge />
                            ) : (
                              <Box
                                sx={{
                                  px: 1,
                                  py: 0.25,
                                  borderRadius: '6px',
                                  backgroundColor: alpha(getStatusColor(evseStatus, theme), 0.12),
                                  color: getStatusColor(evseStatus, theme),
                                  fontSize: '0.62rem',
                                  fontWeight: 700,
                                  textTransform: 'uppercase'
                                }}
                              >
                                {evseStatus}
                              </Box>
                            )}
                          </Paper>
                      </ListItem>
                      )})}
                    {((!charger && isFetching) || isError) && (
                      <React.Fragment>
                        <Skeleton
                          variant="rectangular"
                          sx={{
                            ...paymentStyles.listItemPaper,
                            height: "90px",
                            borderRadius: "16px",
                            flex: "0 0 auto",
                            width: { xs: "80%", sm: 300 },
                          }}
                        />
                        <Skeleton
                          variant="rectangular"
                          sx={{
                            ...paymentStyles.listItemPaper,
                            height: "90px",
                            borderRadius: "16px",
                            flex: "0 0 auto",
                            width: { xs: "80%", sm: 300 },
                          }}
                        />
                        <Skeleton
                          variant="rectangular"
                          sx={{
                            ...paymentStyles.listItemPaper,
                            height: "90px",
                            borderRadius: "16px",
                            flex: "0 0 auto",
                            width: { xs: "80%", sm: 300 },
                          }}
                        />
                      </React.Fragment>
                    )}
                  </List>
                </Box>
              </TabPanel>
            )}

            {reportIssue && (
              <Box className="tabs-parent" sx={paymentStyles.tabParent}>
                <Stack direction="row" alignItems="center" spacing={1} mb={1}>
                  <IconButton
                    size="small"
                    onClick={() => setReportIssue(false)}
                    sx={{ ml: -0.5 }}
                  >
                    <Icon icon={redirectFill} width={22} height={22} />
                  </IconButton>
                  <Typography sx={{ fontWeight: 700, fontSize: "1.05rem" }}>
                    Report an issue
                  </Typography>
                </Stack>
                <Typography variant="body2" color="text.secondary" mb={0.5}>
                  Please select an issue that you've encountered:
                </Typography>
                <Stack
                  direction="column"
                  spacing={1.6}
                  sx={{
                    margin: isSmallScreen ? "1rem 1rem 0" : "1rem 2rem 0",
                    placeItems: "center",
                  }}
                >
                  {reportIssuesList.map((list, index) => {
                    return (
                      <IssueButton
                        key={list.id}
                        variant="outlined"
                        className={
                          reportIssueData.issue === index
                            ? "selected_report_issue"
                            : ""
                        }
                        sx={{ background: "#fff", textTransform: "capitalize" }}
                        onClick={() =>
                          setReportIssueData({
                            issue: index,
                            otherIssue: true,
                            category: list.text,
                          })
                        }
                      >
                        {list.text}
                      </IssueButton>
                    );
                  })}
                  <IssueButton
                    variant="outlined"
                    className={
                      reportIssueData.issue === 4 ? "selected_report_issue" : ""
                    }
                    sx={{ background: "#fff", textTransform: "capitalize" }}
                    onClick={() =>
                      setReportIssueData({
                        issue: 4,
                        otherIssue: true,
                        category: "Other",
                      })
                    }
                  >
                    Other
                  </IssueButton>
                  {reportIssueData.otherIssue && (
                    <Paper
                      sx={{ padding: "1rem" }}
                      component="div"
                      elevation={0}
                      variant="outlined"
                      square
                    >
                      <Typography variant="body2" mb={1}>
                        {Constant.label.ISSUE_PARA}
                      </Typography>
                      <TextField
                        id="others-issue"
                        placeholder="Placeholder"
                        value={reportIssueData.message}
                        multiline
                        rows={3}
                        fullWidth
                        onChange={(e) => onChangeOtherIssue(e)}
                        // sx={styles.textArea}
                      />
                    </Paper>
                  )}
                  <IssueButton
                    variant="contained"
                    color="primary"
                    onClick={() => onSubmitReportIssue()}
                  >
                    SUBMIT
                  </IssueButton>
                </Stack>
              </Box>
            )}

            {!reportIssue && (
              <TabPanel value={value} index={1} height={tabContentHeight} className="tab-list tab-info">
                <Box>
                  <MarkerInformationTab
                    locationDetail={chargerData}
                    forLocationTab={false}
                  />
                </Box>
              </TabPanel>
            )}
            {!reportIssue && (
              <TabPanel value={value} index={2} height={tabContentHeight} className="tab-list tab-info">
                <Box className="tabs-parent" sx={paymentStyles.tabParent}>
                  <SectionTitle>Frequently Asked Questions</SectionTitle>

                  {(!faqData || faqData.filter(faq => faq.question && faq.question.trim().length > 0).length === 0) ? (
                    <Box sx={{ py: 6, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', opacity: 0.6 }}>
                      <LiveHelpOutlinedIcon sx={{ fontSize: 56, color: 'text.disabled', mb: 1.5 }} />
                      <Typography variant="body2" color="text.secondary" fontWeight={500}>
                        No FAQs available yet
                      </Typography>
                    </Box>
                  ) : (
                    faqData.filter(faq => faq.question && faq.question.trim().length > 0).map((faqs, index) => {
                      return (
                        <Accordion
                          key={faqs.id}
                          disableGutters
                          elevation={0}
                          sx={{
                            mb: 1.25,
                            border: (t) => `1px solid ${alpha(t.palette.grey[500], 0.2)}`,
                            borderRadius: "10px !important",
                            overflow: "hidden",
                            "&:before": { display: "none" },
                          }}
                          className="accordion_content"
                        >
                          <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls={`faq-content-${index}`}
                            id={`faq-header-${index}`}
                            sx={{ "& .MuiAccordionSummary-content": { my: 1.25 } }}
                          >
                            <Typography textAlign="left" sx={{ fontWeight: 600, fontSize: "0.9rem" }}>
                              {faqs.question}
                            </Typography>
                          </AccordionSummary>
                          <AccordionDetails sx={{ pt: 0 }}>
                            <Typography variant="body2" color="text.secondary" textAlign="left" sx={{ lineHeight: 1.6 }}>
                              {faqs.answer}
                            </Typography>
                          </AccordionDetails>
                        </Accordion>
                      );
                    })
                  )}
                </Box>
              </TabPanel>
            )}
            {!reportIssue && (
              <TabPanel value={value} index={3} height={tabContentHeight} className="tab-list tab-info">
                <Box className="tabs-parent" sx={paymentStyles.tabParent}>
                  <SectionTitle>Photos</SectionTitle>
                  {(!chargerData?.photos || chargerData.photos.length === 0) ? (
                    <Box sx={{ py: 6, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', opacity: 0.6 }}>
                      <PhotoLibraryOutlinedIcon sx={{ fontSize: 56, color: 'text.disabled', mb: 1.5 }} />
                      <Typography variant="body2" color="text.secondary" fontWeight={500}>
                        No photos available yet
                      </Typography>
                    </Box>
                  ) : (
                    <ImageList cols={isSmallScreen ? 2 : 3} rowHeight={isSmallScreen ? 120 : 110} gap={12}>
                      {chargerData.photos.map((photo, index) => (
                        <ImageListItem
                          key={index}
                          sx={{
                            borderRadius: "12px",
                            overflow: "hidden",
                            cursor: "pointer",
                            transition: "transform 0.2s ease, box-shadow 0.2s ease",
                            "&:hover": {
                              transform: "translateY(-2px)",
                              boxShadow: "0 6px 16px rgba(145,158,171,0.24)",
                            },
                            "& img": { width: "100%", height: "100%", objectFit: "cover" },
                          }}
                        >
                          <img
                            src={photo}
                            alt="Charger"
                            loading="lazy"
                            onClick={() => {
                              setPhotoModal({ open: true, src: photo });
                            }}
                          />
                        </ImageListItem>
                      ))}
                    </ImageList>
                  )}
                  <Dialog
                    onClose={() => {
                      setPhotoModal({ open: false, src: "" });
                    }}
                    aria-labelledby="customized-dialog-title"
                    open={photoModal.open}
                  >
                    <Tooltip title="Close Photo" placement="bottom">
                    <IconButton
                      aria-label="close"
                      onClick={() => {
                        setPhotoModal({ open: false, src: "" });
                      }}
                      sx={{
                        position: "absolute",
                        right: 0,
                        top: 0,
                      }}
                    >
                      <CloseIcon />
                    </IconButton>
                    </Tooltip>
                    <DialogContent
                      sx={{
                        minHeight: "300px",
                        minWidth: isSmallScreen ? "100%" : "600px",
                        display: "flex",
                        placeItems: "center",
                        placeContent: "center",
                        padding: isSmallScreen ? "30px 16px" : "32px 40px",
                      }}
                    >
                      <img src={photoModal.src} alt="Review" />
                    </DialogContent>
                  </Dialog>
                </Box>
              </TabPanel>
            )}
            </Box>

            {!reportIssue &&
              (!!charger?.pay_with_card || !!charger?.employee_or_resident) && (
                <EmailComponent
                  connector={connector}
                  email={email}
                  setEmail={setEmail}
                  // customerName = {customerName}
                  // setCustomerName= {setCustomerName}
                  chargerId={chargerId}
                  setPaymentStatus={setPaymentStatus}
                  setGuest={setGuest}
                  payWithCard={!!charger?.pay_with_card}
                  employeeOrResident={!!charger?.employee_or_resident}
                />
              )}
            {!reportIssue && connector && !!charger?.pay_with_card && !isConnectorFree && (
              <PaymentForm
                clientHandler={clientHandler}
                chargerId={chargerId}
                email={email}
                companyId={charger.companyId}
                domain={charger?.domain}
                // customerName={customerName}
                connector={connector}
                submitHandler={setPaymentStatus}
                paymentMethod={{
                  keyId: charger?.key_id,
                  id: charger?.payment_gateway_id,
                }}
              />
            )}
            {showCardInfo && clientId && (
              <Box
                className="tabs-parent"
                sx={{
                  ...paymentStyles.tabParent,
                }}
              >
                <StripeCheckout
                  clientId={clientId}
                  submitHandler={setPaymentStatus}
                  keyId={charger?.key_id}
                  chargerId={chargerId}
                  connectorId={
                    !is.empty(connector?.ocpi_connector_id)
                      ? connector?.ocpi_connector_id
                      : connector?.connector_id
                  }
                  email={email}
                />
              </Box>
            )}
          </>
        )}
        </Card>
      </Container>

      <MuiSnackBar
        open={reportStat.open}
        severity={reportStat.variant}
        message={reportStat.message}
        onCloseFunc={() =>
          setReportStat((messageOp) => ({ ...messageOp, open: false }))
        }
      />
    </Page>
  );
};
